export default __webpack_public_path__ + "static/media/daCrazyWhiteMode.dd0a2507.svg";